import { ApiMethods, ApiTags, appAPI } from '.';

interface GetClientVisibilityCountParams {
  id: string;
}

type GetClientVisibilityCountResponse = number;

export const clientVisibilityApi = appAPI.injectEndpoints({
  endpoints: (build) => ({
    getClientVisibilityCount: build.query<
      GetClientVisibilityCountResponse,
      GetClientVisibilityCountParams
    >({
      query: ({ id }: { id: string }) => ({
        path: `/app-instances/${id}/visibility-count`,
        method: ApiMethods.get,
        options: {},
      }),
      providesTags: [ApiTags.app_visibility],
    }),
  }),
});

export const { useGetClientVisibilityCountQuery } = clientVisibilityApi;
